import React from "react";
import { Icon, TextField } from "stories/Admin";
import styles from "./ExternalPage.module.scss";

interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}

const SearchField: React.FC<SearchFieldProps> = ({
  value,
  onChange,
  placeholder,
}) => (
  <div className={styles.search}>
    <Icon
      name="search"
      size={18}
      strokeWidth={2}
      className={styles.searchIcon}
    />
    <TextField
      type="search"
      aria-label={placeholder}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);

/** True when every word in the query appears in one of the fields. */
export const matchesSearch = (
  query: string,
  fields: Array<string | null | undefined>,
): boolean => {
  const words = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (words.length === 0) return true;
  const haystack = fields.filter(Boolean).join(" ").toLowerCase();
  return words.every((word) => haystack.includes(word));
};

export default SearchField;
